import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Chapter } from 'it/primatoo/openapi/api/org/schemas/common/docs/_listtemplatechapterresponse/Chapter';
import { IoniconsFilled, IoniconsOutline } from '@pt/pt-models';
import { ChapterStatus } from 'it/primatoo/openapi/api/org/schemas/common/docs/ChapterStatus';

@Component({
  selector: 'pt-tab-chapter',
  template: `
    <div *ngIf="currentChapter" class="d-flex align-items-center">
      {{ currentChapter?.name }}
      <pt-icon
        *ngIf="currentChapter?.currentStatus"
        class="ms-1 d-flex"
        container='body'
        ngbTooltip="{{'ENUMS.' + currentChapter?.currentStatus | translate}}"
        [ngClass]="'color-'+ currentChapter?.currentStatus?.toLocaleLowerCase()"
        [key]='IconEllipse' [size]='14'></pt-icon>

      <pt-icon class="d-flex" [key]="lock" [size]="14"
               *ngIf="currentChapter?.currentStatus && currentChapter.currentStatus !== WORKING">
      </pt-icon>
    </div>
  `,
  styles: [`
    .color-working {
      color: #ffc107;
    }

    .color-not_started {
      color: #bbbec1;
    }

    .color-terminated {
      color: #6bb700;
    }
  `]
})
export class TabChapterComponent implements OnChanges {
  @Input() chapterId: number;
  @Input() chapters: Array<Chapter>;
  currentChapter?: Chapter;
  IconEllipse = IoniconsFilled.ellipse;
  lock = IoniconsOutline.lock;

  public readonly WORKING = ChapterStatus.WORKING;
  ngOnChanges(changes: SimpleChanges): void {
    this.alignChapterStatus(this.chapterId, this.chapters);
  }

  private alignChapterStatus(chapterId: number, chapters: Array<Chapter>) {
    this.currentChapter = undefined;
    if (Number.isInteger(chapterId) && chapters) {
      const currentChapter = chapters?.find(c => c.id === chapterId);
      if (currentChapter) {
        this.currentChapter = currentChapter;
      }
    }
  }
}

